import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "removeHtmlTags",
})
export class RemoveHtmlTagsPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) {
            return value;
        }
        return value.replace(/<[^>]*>/g, ""); // Expressão regular para remover tags HTML
    }
}
